/* aFe brand shopping page. Docs: AFE-SHOPPING.md */
(function () {
  var root = document.querySelector('[data-afe-shopping]');
  if (!root) return;

  document.documentElement.classList.add('afe-shopping-page');

  var PAGE_STEP = 48;
  var HIDDEN_NAV = { gear: true };
  var SUBTYPE_NAV = [
    ['Induction', 'Cold Air Intake Systems', 'https://cdn.shopify.com/s/files/1/0229/3877/files/coldairintake.jpg?v=1790500349'],
    ['Induction', 'Intake Replacement Air Filters', 'https://cdn.shopify.com/s/files/1/0229/3877/files/Intake_Replacement_Air_Filter.png?v=1790500390'],
    ['Induction', 'Dynamic Air Scoops', 'https://cdn.shopify.com/s/files/1/0229/3877/files/Dynamic_Air_Scoop.png?v=1790500390'],
    ['Induction', 'Throttle Bodies', 'https://cdn.shopify.com/s/files/1/0229/3877/files/Throttle_Bodiesv2.png?v=1790500390'],
    ['Induction', 'Throttle Body Spacers', 'https://cdn.shopify.com/s/files/1/0229/3877/files/ThrottleBodySpacer.jpg?v=1790500390'],
    ['Induction', 'Manifolds', 'https://cdn.shopify.com/s/files/1/0229/3877/files/induction-manifolds-icon.jpg?v=1790500390'],
    ['Induction', 'Pre-Filters', 'https://cdn.shopify.com/s/files/1/0229/3877/files/pre-filters-icon.jpg?v=1790500390'],
    ['Induction', 'Accessories / Misc.', 'https://cdn.shopify.com/s/files/1/0229/3877/files/Induction_Accessory.png?v=1790500390'],
    ['Induction', 'Cleaning Kits', 'https://cdn.shopify.com/s/files/1/0229/3877/files/Induction_cleaning_kit.png?v=1790500390'],
    ['Filtration', 'Engine OE Replacement Filters', 'https://cdn.shopify.com/s/files/1/0229/3877/files/Engine_OE_Replacement_Filters.png?v=1790500390'],
    ['Filtration', 'Universal Air Filters', 'https://cdn.shopify.com/s/files/1/0229/3877/files/Universal_Air_Filter.png?v=1790500390'],
    ['Filtration', 'Cabin Air Filters', 'https://cdn.shopify.com/s/files/1/0229/3877/files/Cabin-Air-Filter-icon.jpg?v=1790500390'],
    ['Filtration', 'Oil Filters', 'https://cdn.shopify.com/s/files/1/0229/3877/files/Oil_Filter_V1.png?v=1790500390'],
    ['Filtration', 'Fuel Filters', 'https://cdn.shopify.com/s/files/1/0229/3877/files/Fuel_Filter_V1.png?v=1790500390'],
    ['Filtration', 'Transmission Filters', 'https://cdn.shopify.com/s/files/1/0229/3877/files/Transmission_Filter.png?v=1790500390'],
    ['Filtration', 'Cleaning Kits', 'https://cdn.shopify.com/s/files/1/0229/3877/files/Cleaning_Kit.png?v=1790500390'],
    ['Filtration', 'Filter Packs', 'https://cdn.shopify.com/s/files/1/0229/3877/files/Maintenance_Kits.png?v=1790500390'],
    ['Exhaust', 'Exhaust Systems', 'https://cdn.shopify.com/s/files/1/0229/3877/files/exhaustsystems-icon.jpg?v=1790500390'],
    ['Exhaust', 'Headers', 'https://cdn.shopify.com/s/files/1/0229/3877/files/headers-icon.jpg?v=1790500390'],
    ['Exhaust', 'Y-Pipes', 'https://cdn.shopify.com/s/files/1/0229/3877/files/y-pipes.png?v=1790500390'],
    ['Exhaust', 'Down-Pipes', 'https://cdn.shopify.com/s/files/1/0229/3877/files/down-pipes-icon.jpg?v=1790500390'],
    ['Exhaust', 'Manifolds', 'https://cdn.shopify.com/s/files/1/0229/3877/files/exhaustmanifolds-icon.jpg?v=1790500390'],
    ['Exhaust', 'Catalytic Converters', 'https://cdn.shopify.com/s/files/1/0229/3877/files/catalyticconverters_icon_63273b64-35df-45ff-9b36-fd1f509e5006.jpg?v=1790500390'],
    ['Exhaust', 'Mufflers', 'https://cdn.shopify.com/s/files/1/0229/3877/files/mufflers-icon.jpg?v=1790500390'],
    ['Exhaust', 'Tips', 'https://cdn.shopify.com/s/files/1/0229/3877/files/exh-tip-icon.jpg?v=1790500390'],
    ['Forced Induction', 'Intercoolers', 'https://cdn.shopify.com/s/files/1/0229/3877/files/intercoolers-icon.jpg?v=1790500390'],
    ['Forced Induction', 'Charge Pipes', 'https://cdn.shopify.com/s/files/1/0229/3877/files/Charge_Pipes.png?v=1790500390'],
    ['Forced Induction', 'Silicone Couplings', 'https://cdn.shopify.com/s/files/1/0229/3877/files/SilconeCouplings.png?v=1790500390'],
    ['Forced Induction', 'Turbochargers', 'https://cdn.shopify.com/s/files/1/0229/3877/files/turbocharger-icon.jpg?v=1790500390'],
    ['Suspension', 'Shocks', 'https://cdn.shopify.com/s/files/1/0229/3877/files/shocks-icon.jpg?v=1790500390'],
    ['Suspension', 'Springs', 'https://cdn.shopify.com/s/files/1/0229/3877/files/springs-icon.jpg?v=1790500390'],
    ['Suspension', 'Coilovers', 'https://cdn.shopify.com/s/files/1/0229/3877/files/Coilovers.png?v=1790500390'],
    ['Suspension', 'Sway Bars', 'https://cdn.shopify.com/s/files/1/0229/3877/files/swaybars-icon.jpg?v=1790500390'],
    ['Suspension', 'Packages', 'https://cdn.shopify.com/s/files/1/0229/3877/files/sus-package-icon.jpg?v=1790500390'],
    ['Suspension', 'Bushings', 'https://cdn.shopify.com/s/files/1/0229/3877/files/Bushings.png?v=1790500390'],
    ['Suspension', 'Chassis', 'https://cdn.shopify.com/s/files/1/0229/3877/files/Chassis.png?v=1790500390'],
    ['Suspension', 'Components', 'https://cdn.shopify.com/s/files/1/0229/3877/files/Sus_Components.png?v=1790500390'],
    ['Suspension', 'Race Shocks', 'https://cdn.shopify.com/s/files/1/0229/3877/files/RaceShocks.png?v=1790500390'],
    ['Suspension', 'Leveling/Lift Kits', 'https://cdn.shopify.com/s/files/1/0229/3877/files/LevelingKits.jpg?v=1790500390'],
    ['Suspension', 'Strut Braces', 'https://cdn.shopify.com/s/files/1/0229/3877/files/strut-brace-icon.jpg?v=1790500390'],
    ['Suspension', 'Wheel Spacers', 'https://cdn.shopify.com/s/files/1/0229/3877/files/wheelspacer_icon_square.jpg?v=1790500390'],
    ['Suspension', 'Shock Oils', 'https://cdn.shopify.com/s/files/1/0229/3877/files/Shock_Oil.png?v=1790500390'],
    ['Electronics', 'Power Modules', 'https://cdn.shopify.com/s/files/1/0229/3877/files/Power_Modules.png?v=1790500390'],
    ['Electronics', 'Throttle Enhancer Modules', 'https://cdn.shopify.com/s/files/1/0229/3877/files/Throttle_Enhancer.png?v=1790500390'],
    ['Electronics', 'Brake/Shift Modules', 'https://cdn.shopify.com/s/files/1/0229/3877/files/Brake_Controller.png?v=1790500390'],
    ['Electronics', 'Ignition Coils', 'https://cdn.shopify.com/s/files/1/0229/3877/files/Ignition_Coil3.png?v=1790500390'],
    ['Electronics', 'Pigtails/ Harnesses', 'https://cdn.shopify.com/s/files/1/0229/3877/files/Pigtails-Harnesses.png?v=1790500390'],
    ['Protection / Exterior', 'Covers & Pans', 'https://cdn.shopify.com/s/files/1/0229/3877/files/coversandpans-icon.jpg?v=1790500390'],
    ['Protection / Exterior', 'Fuel Systems', 'https://cdn.shopify.com/s/files/1/0229/3877/files/fuelsystems-icon.jpg?v=1790500390'],
    ['Protection / Exterior', 'Oil Coolers', 'https://cdn.shopify.com/s/files/1/0229/3877/files/OilCooler.png?v=1790500390'],
    ['Protection / Exterior', 'Radiators', 'https://cdn.shopify.com/s/files/1/0229/3877/files/Radiator.png?v=1790500390'],
    ['Protection / Exterior', 'Grilles', 'https://cdn.shopify.com/s/files/1/0229/3877/files/grilles-icon.jpg?v=1790500390'],
    ['Protection / Exterior', 'Body Armor', 'https://cdn.shopify.com/s/files/1/0229/3877/files/BodyArmor.jpg?v=1790500390'],
    ['Protection / Exterior', 'Tow Hooks', 'https://cdn.shopify.com/s/files/1/0229/3877/files/tow-hook-icon_2.1671641705.png?v=1790500390'],
    ['Protection / Exterior', 'Expansion Tanks', 'https://cdn.shopify.com/s/files/1/0229/3877/files/Expansion_Tanks.png?v=1790500390'],
    ['Protection / Exterior', 'Gear Oil / Fuel Additive', 'https://cdn.shopify.com/s/files/1/0229/3877/files/Gear_Oil_Fuel_additivev2.png?v=1790500390'],
    ['Universal Racing Products', 'Couplers', 'https://cdn.shopify.com/s/files/1/0229/3877/files/Couplings.png?v=1790500390'],
    ['Universal Racing Products', 'Clamps', 'https://cdn.shopify.com/s/files/1/0229/3877/files/Clamps.png?v=1790500390']
  ];

  function subtypeRank(part, sub) {
    for (var i = 0; i < SUBTYPE_NAV.length; i += 1) {
      if (SUBTYPE_NAV[i][0] === part && SUBTYPE_NAV[i][1] === sub) return i;
    }
    return 1000;
  }

  function subtypeImage(part, sub) {
    var rank = subtypeRank(part, sub);
    return rank < 1000 ? SUBTYPE_NAV[rank][2] : '';
  }

  var configEl = document.getElementById('afe-config');
  var config = {};
  try {
    config = JSON.parse(configEl ? configEl.textContent : '{}');
  } catch (err) {
    config = {};
  }

  var navEl = root.querySelector('[data-afe-nav-items]');
  var yearEl = root.querySelector('[data-afe-year]');
  var makeEl = root.querySelector('[data-afe-make]');
  var modelEl = root.querySelector('[data-afe-model]');
  var clearEl = root.querySelector('[data-afe-clear]');
  var searchEl = root.querySelector('[data-afe-search]');
  var subsEl = root.querySelector('[data-afe-subs]');
  var statusEl = root.querySelector('[data-afe-status]');
  var gridEl = root.querySelector('[data-afe-grid]');
  var emptyEl = root.querySelector('[data-afe-empty]');
  var moreEl = root.querySelector('[data-afe-more]');
  var modalEl = root.querySelector('[data-afe-modal]');
  var cartCountEl = root.querySelector('[data-afe-cart-count]');

  var products = [];
  var detailCache = {};
  var state = {
    partType: null,
    subType: '',
    year: '',
    make: '',
    model: '',
    query: '',
    visible: PAGE_STEP,
    modalId: null,
    modalTab: 'details',
    modalVariantId: null
  };

  function setStatus(text, warn) {
    if (!statusEl) return;
    statusEl.textContent = text || '';
    statusEl.classList.toggle('is-warn', !!warn);
  }

  function asList(value) {
    if (Array.isArray(value)) {
      return value.map(function (item) { return String(item || '').trim(); }).filter(Boolean);
    }
    if (value && typeof value === 'string' && value.trim()) return [value.trim()];
    return [];
  }

  function keyOf(value) {
    return String(value || '').trim().toLowerCase();
  }

  function parseYearSpan(label) {
    var compact = String(label || '').replace(/[\u2013\u2014]/g, '-').replace(/\s+/g, '');
    var bits = compact.split('-').filter(Boolean);
    var start = parseInt(bits[0], 10);
    var end = bits.length > 1 ? parseInt(bits[bits.length - 1], 10) : start;
    if (!isFinite(start) || !isFinite(end)) return null;
    if (String(Math.abs(start)).length !== 4 || String(Math.abs(end)).length !== 4) return null;
    if (end < start) {
      var swap = start;
      start = end;
      end = swap;
    }
    if (end - start > 40) return null;
    return { start: start, end: end };
  }

  function normalize(raw, index) {
    var fitments = [];
    (raw.fitments || []).forEach(function (row) {
      var span = parseYearSpan(row && row.y);
      var make = String((row && row.k) || '').trim();
      var model = String((row && row.m) || '').trim();
      if (!span || !make || !model) return;
      fitments.push({
        yearLabel: String(row.y).trim(),
        start: span.start,
        end: span.end,
        make: make,
        model: model,
        makeKey: keyOf(make),
        modelKey: keyOf(model)
      });
    });

    var skus = [];
    (raw.variants || []).forEach(function (variant) {
      if (variant && variant.sku) skus.push(String(variant.sku));
    });

    var partTypes = asList(raw.partTypes);
    var subTypes = asList(raw.subTypes);
    var product = {
      id: raw.id,
      title: raw.title || '',
      handle: raw.handle || '',
      vendor: raw.vendor || '',
      shopifyType: raw.shopifyType || '',
      image: raw.image || '',
      price: raw.price || '',
      priceCents: raw.priceCents || 0,
      compareAt: raw.compareAt || '',
      compareAtCents: raw.compareAtCents || 0,
      available: raw.available !== false,
      variantId: raw.variantId || null,
      partTypes: partTypes,
      subTypes: subTypes,
      variants: raw.variants || [],
      fitments: fitments,
      skus: skus,
      _catalogIndex: index
    };
    product._q = [
      product.title,
      product.vendor,
      product.handle,
      product.shopifyType,
      partTypes.join(' '),
      subTypes.join(' '),
      skus.join(' '),
      fitments.map(function (row) {
        return row.yearLabel + ' ' + row.make + ' ' + row.model;
      }).join(' ')
    ].join(' ').toLowerCase();
    return product;
  }

  function dedupe() {
    var seen = {};
    products = products.filter(function (product) {
      var id = String(product.id);
      if (seen[id]) return false;
      seen[id] = true;
      return true;
    });
    products.sort(function (a, b) { return a._catalogIndex - b._catalogIndex; });
  }

  function inStock(product) {
    return product.available === true;
  }

  function inPart(product) {
    if (!state.partType) return false;
    return product.partTypes.indexOf(state.partType) !== -1;
  }

  function inSub(product) {
    if (!state.subType) return true;
    return product.subTypes.indexOf(state.subType) !== -1;
  }

  function coversVehicle(product) {
    if (!state.year && !state.make && !state.model) return true;
    if (!product.fitments.length) return false;
    var year = state.year ? Number(state.year) : 0;
    return product.fitments.some(function (row) {
      if (year && (year < row.start || year > row.end)) return false;
      if (state.make && row.makeKey !== state.make) return false;
      if (state.model && row.modelKey !== state.model) return false;
      return true;
    });
  }

  function matchesQuery(product) {
    var query = state.query.trim().toLowerCase();
    if (!query) return true;
    return query.split(/\s+/).filter(Boolean).every(function (token) {
      return product._q.indexOf(token) !== -1;
    });
  }

  function stockProducts() {
    return products.filter(inStock);
  }

  function partPool() {
    return stockProducts().filter(inPart);
  }

  function visibleProducts() {
    return products.filter(function (product) {
      return inStock(product) && inPart(product) && inSub(product) && coversVehicle(product) && matchesQuery(product);
    });
  }

  function fillSelect(select, placeholder, options, selected) {
    var html = '<option value="">' + placeholder + '</option>';
    options.forEach(function (option) {
      html += '<option value="' + escapeAttr(option.value) + '">' + escapeHtml(option.label) + '</option>';
    });
    select.innerHTML = html;
    select.value = selected && Array.prototype.some.call(select.options, function (opt) { return opt.value === selected; })
      ? selected
      : '';
  }

  function rebuildVehicleControls() {
    var pool = stockProducts();
    var years = {};
    pool.forEach(function (product) {
      product.fitments.forEach(function (row) {
        for (var year = row.start; year <= row.end; year += 1) years[year] = true;
      });
    });
    var yearOptions = Object.keys(years).map(function (year) {
      return { value: year, label: year };
    }).sort(function (a, b) { return Number(b.value) - Number(a.value); });
    fillSelect(yearEl, 'All years', yearOptions, state.year);
    state.year = yearEl.value;

    var makes = {};
    pool.forEach(function (product) {
      product.fitments.forEach(function (row) {
        if (state.year) {
          var year = Number(state.year);
          if (year < row.start || year > row.end) return;
        }
        if (!makes[row.makeKey]) makes[row.makeKey] = row.make;
      });
    });
    var makeOptions = Object.keys(makes).map(function (key) {
      return { value: key, label: makes[key] };
    }).sort(function (a, b) { return a.label.localeCompare(b.label); });
    var phone = window.matchMedia('(max-width: 820px)').matches;
    var makeReady = !!state.year && makeOptions.length > 0;
    makeEl.disabled = !makeReady;
    fillSelect(makeEl, makeReady ? 'All makes' : (phone ? 'Make' : 'Select year first'), makeReady ? makeOptions : [], state.make);
    state.make = makeEl.value;

    var models = {};
    if (state.year && state.make) {
      pool.forEach(function (product) {
        product.fitments.forEach(function (row) {
          var year = Number(state.year);
          if (year < row.start || year > row.end) return;
          if (row.makeKey !== state.make) return;
          if (!models[row.modelKey]) models[row.modelKey] = row.model;
        });
      });
    }
    var modelOptions = Object.keys(models).map(function (key) {
      return { value: key, label: models[key] };
    }).sort(function (a, b) { return a.label.localeCompare(b.label); });
    var modelReady = !!state.year && !!state.make && modelOptions.length > 0;
    modelEl.disabled = !modelReady;
    fillSelect(modelEl, modelReady ? 'All models' : (phone ? 'Model' : 'Select make first'), modelReady ? modelOptions : [], state.model);
    state.model = modelEl.value;
    clearEl.hidden = !(state.year || state.make || state.model);
  }

  function partTypeCounts() {
    var counts = {};
    products.forEach(function (product) {
      if (!inStock(product) || !coversVehicle(product)) return;
      product.partTypes.forEach(function (type) {
        if (HIDDEN_NAV[keyOf(type)]) return;
        counts[type] = (counts[type] || 0) + 1;
      });
    });
    return Object.keys(counts).map(function (type) {
      return { id: type, label: type, count: counts[type] };
    }).sort(function (a, b) {
      if (b.count !== a.count) return b.count - a.count;
      return a.label.localeCompare(b.label);
    });
  }

  function renderNav() {
    var types = partTypeCounts();
    if (!types.length) {
      navEl.innerHTML = '<p class="afe-nav__loading">No part types on in-stock products</p>';
      state.partType = '';
      return;
    }
    var partStillValid = types.some(function (type) { return type.id === state.partType; });
    if (!partStillValid) state.partType = types[0].id;
    var html = '';
    types.forEach(function (type) {
      html += '<button type="button" class="afe-nav__item' + (state.partType === type.id ? ' is-active' : '') + '" data-afe-part="' + escapeAttr(type.id) + '">' +
        '<span class="afe-nav__label">' + escapeHtml(type.label) + '</span></button>';
    });
    navEl.innerHTML = html;
  }

  function renderSubs() {
    var counts = {};
    partPool().forEach(function (product) {
      if (!coversVehicle(product)) return;
      product.subTypes.forEach(function (sub) {
        counts[sub] = (counts[sub] || 0) + 1;
      });
    });
    var subs = Object.keys(counts).sort(function (a, b) {
      var rank = subtypeRank(state.partType, a) - subtypeRank(state.partType, b);
      if (rank !== 0) return rank;
      return a.localeCompare(b);
    });
    if (!subs.length) {
      subsEl.hidden = true;
      subsEl.innerHTML = '';
      state.subType = '';
      return;
    }
    if (state.subType && subs.indexOf(state.subType) === -1) state.subType = '';
    var html = '';
    subs.forEach(function (sub) {
      var image = subtypeImage(state.partType, sub);
      html += '<button type="button" class="afe-subs__item' + (state.subType === sub ? ' is-active' : '') + '" data-afe-sub="' + escapeAttr(sub) + '">' +
        (image ? '<img class="afe-subs__photo" src="' + escapeAttr(image) + '" alt="">' : '') +
        '<span class="afe-subs__label">' + escapeHtml(sub) + '</span></button>';
    });
    subsEl.innerHTML = html;
    subsEl.hidden = false;
  }

  function priceHtml(product) {
    var html = escapeHtml(product.price || '');
    if (product.compareAt && product.compareAtCents > product.priceCents) {
      html += ' <s>' + escapeHtml(product.compareAt) + '</s>';
    }
    return html;
  }

  function renderGrid() {
    var list = visibleProducts();
    var shown = list.slice(0, state.visible);
    var vehicleBits = [];
    if (state.year) vehicleBits.push(state.year);
    if (state.make) {
      var makeLabel = makeEl.options[makeEl.selectedIndex] ? makeEl.options[makeEl.selectedIndex].text : state.make;
      vehicleBits.push(makeLabel);
    }
    if (state.model) {
      var modelLabel = modelEl.options[modelEl.selectedIndex] ? modelEl.options[modelEl.selectedIndex].text : state.model;
      vehicleBits.push(modelLabel);
    }
    var status = list.length + (list.length === 1 ? ' product' : ' products');
    if (vehicleBits.length) status += ' · ' + vehicleBits.join(' ');
    var typed = products.some(function (product) { return product.partTypes.length > 0; });
    if (!typed) {
      setStatus('Catalog loaded, but custom.afe_part_type is empty on these products. Confirm that metafield is storefront-readable.', true);
    } else {
      setStatus(status, false);
    }

    emptyEl.hidden = list.length > 0;
    moreEl.hidden = shown.length >= list.length;
    moreEl.textContent = 'Show more (' + (list.length - shown.length) + ')';

    var html = '';
    shown.forEach(function (product) {
      var typeLabel = state.partType || product.partTypes[0] || product.shopifyType || '';
      var sku = product.skus[0] || '';
      html += '<button type="button" class="afe-card" data-afe-card="' + escapeAttr(product.id) + '">' +
        '<span class="afe-card__photo">' +
          (product.image ? '<img src="' + escapeAttr(product.image) + '" alt="" width="800" height="800">' : '') +
        '</span>' +
        '<span class="afe-card__copy">' +
          (typeLabel ? '<span class="afe-card__type">' + escapeHtml(typeLabel) + '</span>' : '') +
          '<span class="afe-card__title">' + escapeHtml(product.title) + '</span>' +
          (sku ? '<span class="afe-card__sku">' + escapeHtml(sku) + '</span>' : '') +
          '<span class="afe-card__price">' + priceHtml(product) + '</span>' +
        '</span></button>';
    });
    gridEl.innerHTML = html;
  }

  function renderBrowse() {
    rebuildVehicleControls();
    renderSubs();
    renderGrid();
  }

  function render() {
    renderNav();
    renderBrowse();
  }

  function findProduct(id) {
    var wanted = String(id);
    for (var i = 0; i < products.length; i += 1) {
      if (String(products[i].id) === wanted) return products[i];
    }
    return null;
  }

  function sanitizeHtml(html) {
    return String(html || '')
      .replace(/<script[\s\S]*?<\/script>/gi, '')
      .replace(/\son\w+=(\"[^\"]*\"|'[^']*')/gi, '');
  }

  function fitmentTable(product) {
    var seen = {};
    var rows = [];
    product.fitments.forEach(function (row) {
      var key = row.yearLabel + '|' + row.makeKey + '|' + row.modelKey;
      if (seen[key]) return;
      seen[key] = true;
      rows.push(row);
    });
    if (!rows.length) return '<p>No year, make, and model rows on this product.</p>';
    var html = '<table class="afe-fit-table"><thead><tr><th>Year</th><th>Make</th><th>Model</th></tr></thead><tbody>';
    rows.forEach(function (row) {
      html += '<tr><td>' + escapeHtml(row.yearLabel) + '</td><td>' + escapeHtml(row.make) + '</td><td>' + escapeHtml(row.model) + '</td></tr>';
    });
    html += '</tbody></table>';
    return html;
  }

  function selectedVariant(product) {
    var variants = product.variants || [];
    var chosen = null;
    variants.forEach(function (variant) {
      if (chosen) return;
      if (String(variant.id) === String(state.modalVariantId)) chosen = variant;
    });
    if (chosen) return chosen;
    variants.forEach(function (variant) {
      if (chosen) return;
      if (variant.available) chosen = variant;
    });
    return chosen || variants[0] || null;
  }

  function renderModal(product) {
    var variant = selectedVariant(product);
    state.modalVariantId = variant ? variant.id : product.variantId;
    root.querySelector('[data-afe-modal-title]').textContent = product.title;
    root.querySelector('[data-afe-modal-kicker]').textContent = product.partTypes.join(' · ') || product.vendor || 'aFe';
    var price = variant && variant.price ? variant.price : product.price;
    var compare = product.compareAt && product.compareAtCents > product.priceCents ? '<s>' + escapeHtml(product.compareAt) + '</s>' : '';
    root.querySelector('[data-afe-modal-price]').innerHTML = escapeHtml(price || '') + compare;

    var variantWrap = root.querySelector('[data-afe-modal-variant-wrap]');
    var variantSelect = root.querySelector('[data-afe-modal-variant]');
    var realVariants = (product.variants || []).filter(function (item) {
      return item && item.title && item.title !== 'Default Title';
    });
    if (realVariants.length > 1) {
      variantWrap.hidden = false;
      variantSelect.innerHTML = realVariants.map(function (item) {
        return '<option value="' + escapeAttr(item.id) + '"' + (String(item.id) === String(state.modalVariantId) ? ' selected' : '') + '>' +
          escapeHtml(item.title) + (item.available ? '' : ' — sold out') + '</option>';
      }).join('');
    } else {
      variantWrap.hidden = true;
      variantSelect.innerHTML = '';
    }

    root.querySelector('[data-afe-modal-fitment]').innerHTML = fitmentTable(product);
    var atc = root.querySelector('[data-afe-atc]');
    atc.disabled = !(variant && variant.available);
    atc.textContent = variant && variant.available ? 'Add to cart' : 'Sold out';
    atc.setAttribute('data-variant-id', state.modalVariantId || '');

    setModalTab(state.modalTab || 'details');
    var cached = detailCache[product.handle];
    var descEl = root.querySelector('[data-afe-modal-desc]');
    if (cached) {
      renderDetails(descEl, cached);
      renderThumbs(cached.images && cached.images.length ? cached.images : [product.image]);
    } else {
      descEl.textContent = 'Loading description…';
      renderThumbs(product.image ? [product.image] : []);
      loadDetail(product);
    }
    applyModalImage(product);
    modalEl.hidden = false;
  }

  function applyModalImage(product) {
    var variant = selectedVariant(product);
    var imageEl = root.querySelector('[data-afe-modal-image]');
    var src = (variant && variant.image) || product.image || '';
    if (!src) return;
    imageEl.src = src;
    imageEl.alt = product.title;
    root.querySelectorAll('[data-afe-thumb]').forEach(function (button) {
      button.classList.toggle('is-active', button.getAttribute('data-afe-thumb') === src);
    });
  }

  function findPartCallout(container) {
    var nodes = container.querySelectorAll('p, li, div, h2, h3, h4');
    for (var i = 0; i < nodes.length; i += 1) {
      var text = (nodes[i].textContent || '').replace(/\s+/g, ' ').trim();
      if (text.length > 120) continue;
      if (/part\s*(#|number|no\.?)\s*:?/i.test(text)) return nodes[i];
    }
    return null;
  }

  var CHART_BUTTONS = [
    {
      key: 'flowChart',
      label: 'Airflow Chart',
      icon: 'https://cdn.shopify.com/s/files/1/0229/3877/files/imgi_16_pdp-files-airflowchart.1473960530.png?v=1790566363'
    },
    {
      key: 'dynoChart',
      label: 'Dyno Chart',
      icon: 'https://cdn.shopify.com/s/files/1/0229/3877/files/imgi_18_pdp-files-dynochart.1473960530.png?v=1790566363'
    }
  ];

  function chartUrl(value) {
    var url = String(value || '').trim();
    if (!/^https?:\/\//i.test(url)) return '';
    return url;
  }

  function instructionsLink(url) {
    var link = document.createElement('a');
    link.className = 'afe-manual';
    link.href = url;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.setAttribute('download', '');
    link.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg><span>Download Instructions</span>';
    return link;
  }

  function chartButtons(data) {
    var row = document.createElement('div');
    row.className = 'afe-charts';
    CHART_BUTTONS.forEach(function (def) {
      var url = chartUrl(data && data[def.key]);
      if (!url) return;
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'afe-chart';
      button.setAttribute('data-afe-chart', url);
      button.setAttribute('data-afe-chart-label', def.label);
      var icon = document.createElement('img');
      icon.src = def.icon;
      icon.alt = '';
      icon.width = 44;
      icon.height = 44;
      var text = document.createElement('span');
      text.textContent = def.label;
      button.appendChild(icon);
      button.appendChild(text);
      row.appendChild(button);
    });
    if (!row.childNodes.length) return null;
    return row;
  }

  function renderDetails(descEl, data) {
    descEl.innerHTML = data && data.description
      ? sanitizeHtml(data.description)
      : '<p>No description on this product.</p>';
    var files = document.createElement('div');
    files.className = 'afe-files';
    var url = data && data.instructionsUrl ? String(data.instructionsUrl).trim() : '';
    if (url) files.appendChild(instructionsLink(url));
    var charts = chartButtons(data);
    if (charts) files.appendChild(charts);
    if (!files.childNodes.length) return;
    var callout = findPartCallout(descEl);
    if (callout) callout.insertAdjacentElement('afterend', files);
    else descEl.insertBefore(files, descEl.firstChild);
  }

  function showChart(url, label) {
    var safe = chartUrl(url);
    if (!safe) return;
    var view = root.querySelector('[data-afe-chart-view]');
    var image = view.querySelector('[data-afe-chart-image]');
    var heading = view.querySelector('[data-afe-chart-label]');
    var name = label || 'Chart';
    heading.textContent = name;
    image.alt = name;
    image.src = safe;
    view.hidden = false;
    modalEl.classList.add('is-chart');
  }

  function hideChart() {
    var view = root.querySelector('[data-afe-chart-view]');
    if (!view) return;
    view.hidden = true;
    modalEl.classList.remove('is-chart');
    var image = view.querySelector('[data-afe-chart-image]');
    image.removeAttribute('src');
    image.alt = '';
  }

  function renderThumbs(images) {
    var wrap = root.querySelector('[data-afe-modal-thumbs]');
    var list = (images || []).filter(Boolean);
    if (list.length < 2) {
      wrap.innerHTML = '';
      return;
    }
    wrap.innerHTML = list.map(function (src, index) {
      return '<button type="button" class="' + (index === 0 ? 'is-active' : '') + '" data-afe-thumb="' + escapeAttr(src) + '"><img src="' + escapeAttr(src) + '" alt=""></button>';
    }).join('');
  }

  function setModalTab(tab) {
    state.modalTab = tab === 'fitment' ? 'fitment' : 'details';
    root.querySelectorAll('[data-afe-tab]').forEach(function (button) {
      button.classList.toggle('is-active', button.getAttribute('data-afe-tab') === state.modalTab);
    });
    root.querySelectorAll('[data-afe-panel]').forEach(function (panel) {
      var on = panel.getAttribute('data-afe-panel') === state.modalTab;
      panel.hidden = !on;
      panel.classList.toggle('is-active', on);
    });
  }

  function closeModal() {
    hideChart();
    modalEl.hidden = true;
    state.modalId = null;
  }

  function loadDetail(product) {
    if (!product.handle || detailCache[product.handle]) return;
    fetch('/products/' + encodeURIComponent(product.handle) + '?view=afe-json', { credentials: 'same-origin' })
      .then(function (res) { return res.text(); })
      .then(function (text) {
        var data = JSON.parse(text);
        detailCache[product.handle] = data;
        if (String(state.modalId) !== String(product.id)) return;
        var descEl = root.querySelector('[data-afe-modal-desc]');
        renderDetails(descEl, data);
        if (data.images && data.images.length) renderThumbs(data.images);
        var openProduct = findProduct(state.modalId);
        if (openProduct) applyModalImage(openProduct);
      })
      .catch(function () {
        if (String(state.modalId) !== String(product.id)) return;
        root.querySelector('[data-afe-modal-desc]').textContent = 'Description could not be loaded.';
      });
  }

  function openModal(id) {
    var product = findProduct(id);
    if (!product) return;
    state.modalId = product.id;
    state.modalVariantId = product.variantId;
    state.modalTab = 'details';
    hideChart();
    renderModal(product);
  }

  function hostCartElement() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function refreshCartCount() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var count = cart && cart.item_count ? Number(cart.item_count) : 0;
        if (!cartCountEl) return;
        cartCountEl.textContent = String(count);
        cartCountEl.hidden = count < 1;
      })
      .catch(function () {});
  }

  function addToCart(variantId, button) {
    if (!variantId || !button || button.disabled) return;
    var hostCart = hostCartElement();
    var body = { id: Number(variantId), quantity: 1 };
    if (hostCart && typeof hostCart.getSectionsToRender === 'function') {
      body.sections = hostCart.getSectionsToRender().map(function (section) { return section.id; }).join(',');
      body.sections_url = window.location.pathname;
    }
    var original = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart');
        return res.json();
      })
      .then(function (data) {
        button.textContent = 'Added';
        button.classList.add('is-added');
        if (hostCart && data && data.sections && typeof hostCart.renderContents === 'function') {
          try { hostCart.renderContents(data); } catch (err) { /* notification is optional */ }
        }
        closeModal();
        refreshCartCount();
        window.setTimeout(refreshCartCount, 400);
        window.setTimeout(function () {
          button.textContent = original || 'Add to cart';
          button.classList.remove('is-added');
          button.disabled = false;
        }, 1200);
      })
      .catch(function () {
        button.textContent = 'Try again';
        button.disabled = false;
        window.setTimeout(function () { button.textContent = original || 'Add to cart'; }, 1400);
      });
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escapeAttr(value) {
    return escapeHtml(value).replace(/'/g, '&#39;');
  }

  function fetchPage(handle, page) {
    var url = '/collections/' + encodeURIComponent(handle) + '?view=afe-json&page=' + page;
    return fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('page ' + page);
        return res.text();
      })
      .then(function (text) {
        var data = JSON.parse(text.trim());
        if (!Array.isArray(data)) throw new Error('page ' + page + ' was not an array');
        return data;
      })
      .catch(function (err) {
        console.warn('[afe-shopping] catalog page failed', page, err);
        return { error: page };
      });
  }

  function loadCatalog() {
    var handle = config.collectionHandle;
    if (!handle) {
      setStatus('AFE collection is not available on this theme.', true);
      return;
    }
    var pageSize = Number(config.pageSize) || 250;
    var count = Number(config.productsCount) || 0;
    var pages = Math.max(1, Math.ceil(count / pageSize));
    if (pages > 40) pages = 40;
    setStatus('Loading ' + count + ' products…');
    var jobs = [];
    for (var page = 1; page <= pages; page += 1) jobs.push(fetchPage(handle, page));
    Promise.all(jobs).then(function (chunks) {
      var index = 0;
      var failed = [];
      chunks.forEach(function (list) {
        if (list && list.error) {
          failed.push(list.error);
          return;
        }
        (list || []).forEach(function (raw) {
          products.push(normalize(raw, index));
          index += 1;
        });
      });
      dedupe();
      if (!products.length) {
        setStatus('Catalog did not load. Check /collections/' + handle + '?view=afe-json', true);
        return;
      }
      state.partType = null;
      state.failedPages = failed;
      render();
      if (failed.length) {
        setStatus(statusEl.textContent + ' · ' + failed.length + ' catalog page(s) failed to load.', true);
      }
    });
  }

  root.addEventListener('click', function (event) {
    var partBtn = event.target.closest('[data-afe-part]');
    if (partBtn && navEl.contains(partBtn)) {
      state.partType = partBtn.getAttribute('data-afe-part');
    if (state.partType == null) state.partType = '';
      state.subType = '';
      state.visible = PAGE_STEP;
      render();
      return;
    }
    var subBtn = event.target.closest('[data-afe-sub]');
    if (subBtn && subsEl.contains(subBtn)) {
      var next = subBtn.getAttribute('data-afe-sub') || '';
      state.subType = state.subType === next ? '' : next;
      state.visible = PAGE_STEP;
      renderGrid();
      renderSubs();
      return;
    }
    var card = event.target.closest('[data-afe-card]');
    if (card) {
      openModal(card.getAttribute('data-afe-card'));
      return;
    }
    var chartBtn = event.target.closest('[data-afe-chart]');
    if (chartBtn) {
      showChart(chartBtn.getAttribute('data-afe-chart'), chartBtn.getAttribute('data-afe-chart-label'));
      return;
    }
    if (event.target.closest('[data-afe-chart-back]')) {
      hideChart();
      return;
    }
    if (event.target.closest('[data-afe-modal-close]')) {
      closeModal();
      return;
    }
    var tab = event.target.closest('[data-afe-tab]');
    if (tab) {
      setModalTab(tab.getAttribute('data-afe-tab'));
      return;
    }
    var thumb = event.target.closest('[data-afe-thumb]');
    if (thumb) {
      root.querySelector('[data-afe-modal-image]').src = thumb.getAttribute('data-afe-thumb');
      root.querySelectorAll('[data-afe-thumb]').forEach(function (button) {
        button.classList.toggle('is-active', button === thumb);
      });
      return;
    }
    if (event.target.closest('[data-afe-atc]')) {
      var atc = event.target.closest('[data-afe-atc]');
      addToCart(atc.getAttribute('data-variant-id'), atc);
    }
  });

  yearEl.addEventListener('change', function () {
    state.year = yearEl.value;
    state.make = '';
    state.model = '';
    state.visible = PAGE_STEP;
    render();
  });
  makeEl.addEventListener('change', function () {
    state.make = makeEl.value;
    state.model = '';
    state.visible = PAGE_STEP;
    render();
  });
  modelEl.addEventListener('change', function () {
    state.model = modelEl.value;
    state.visible = PAGE_STEP;
    render();
  });
  clearEl.addEventListener('click', function () {
    state.year = '';
    state.make = '';
    state.model = '';
    state.visible = PAGE_STEP;
    render();
  });
  searchEl.addEventListener('input', function () {
    state.query = searchEl.value || '';
    state.visible = PAGE_STEP;
    renderGrid();
  });
  moreEl.addEventListener('click', function () {
    state.visible += PAGE_STEP;
    renderGrid();
  });
  root.querySelector('[data-afe-ymm]').addEventListener('submit', function (event) {
    event.preventDefault();
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && modalEl && !modalEl.hidden) {
      var chartView = root.querySelector('[data-afe-chart-view]');
      if (chartView && !chartView.hidden) {
        hideChart();
        return;
      }
      closeModal();
    }
  });
  root.querySelector('[data-afe-modal-variant]').addEventListener('change', function (event) {
    state.modalVariantId = event.target.value;
    var product = findProduct(state.modalId);
    if (!product) return;
    var variant = selectedVariant(product);
    var price = variant && variant.price ? variant.price : product.price;
    var compare = product.compareAt && product.compareAtCents > product.priceCents ? '<s>' + escapeHtml(product.compareAt) + '</s>' : '';
    root.querySelector('[data-afe-modal-price]').innerHTML = escapeHtml(price || '') + compare;
    var atc = root.querySelector('[data-afe-atc]');
    atc.disabled = !(variant && variant.available);
    atc.textContent = variant && variant.available ? 'Add to cart' : 'Sold out';
    atc.setAttribute('data-variant-id', variant ? variant.id : '');
    applyModalImage(product);
  });

  function enableRowScroll(el) {
    if (!el || el.getAttribute('data-afe-row-scroll') === '1') return;
    el.setAttribute('data-afe-row-scroll', '1');
    var drag = null;

    el.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      drag = {
        id: event.pointerId,
        x: event.clientX,
        left: el.scrollLeft,
        moved: false
      };
    });

    el.addEventListener('pointermove', function (event) {
      if (!drag || drag.id !== event.pointerId) return;
      var dx = event.clientX - drag.x;
      if (Math.abs(dx) > 6) drag.moved = true;
      if (!drag.moved) return;
      el.scrollLeft = drag.left - dx;
    });

    function endDrag(event) {
      if (!drag || (event && drag.id !== event.pointerId)) return;
      var moved = drag.moved;
      drag = null;
      if (!moved) return;
      var blockClick = function (clickEvent) {
        clickEvent.preventDefault();
        clickEvent.stopPropagation();
        el.removeEventListener('click', blockClick, true);
      };
      el.addEventListener('click', blockClick, true);
    }

    el.addEventListener('pointerup', endDrag);
    el.addEventListener('pointercancel', endDrag);

    el.addEventListener('wheel', function (event) {
      if (el.scrollWidth <= el.clientWidth + 1) return;
      if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) return;
      el.scrollLeft += event.deltaY;
      event.preventDefault();
    }, { passive: false });
  }

  refreshCartCount();
  enableRowScroll(navEl);
  enableRowScroll(subsEl);
  loadCatalog();
})();
